const createTransactionSimulatorApi = ({ txSimulator }) => ({
    transactionSimulator: {
        simulate: (params) => txSimulator.simulate(params),
    },
});
const transactionSimulatorApiDefinition = {
    id: 'transactionSimulatorApi',
    type: 'api',
    factory: createTransactionSimulatorApi,
    dependencies: ['txSimulator'],
};
export default transactionSimulatorApiDefinition;
